import type { RouteLocationNormalized } from 'vue-router'
import isArray from 'lodash/isArray'

export const routeValidate = (route: RouteLocationNormalized): boolean => {
  if (!('slug' in route.params)) {
    return false
  }

  const slugs = route.params.slug
  const isSlug = (value: string): boolean => {
    return /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value)
  }

  if (typeof slugs === 'string') {
    return isSlug(slugs)
  }

  return isArray(slugs) && slugs.filter(isSlug).length > 0
}
